<template>
  <div :class="$style.header" :data-is-home="$route.path === '/' || isPageForHeader">
    <!-- 상단 헤더 (로고 + 로그인 버튼) -->
    <div :class="$style.topHeader">
      <div :class="$style.logoDiv">
        <img :class="$style.logo" alt="Linkook logo" src="@/assets/images/linkooklive_longlogo.png" @click="goToOff"
          style="cursor: pointer" />
      </div>

      <div :class="$style.buttons">
        <!-- 로그인 관련 버튼들 -->
        <button v-if="!userStore.isLogin" :class="$style.loginButton" @click="showLoginPopup">
          로그인
        </button>

        <button v-if="userStore.isLogin" :class="$style.profileButton" @click="toggleDropdown" ref="profileTrigger"
          title="프로필 메뉴">
          <img v-if="userStore.profileImage" :src="userStore.profileImage" :alt="userStore.nickname || '프로필'"
            :class="$style.profileImage" />
          <div v-else :class="$style.defaultProfile">
            <img :src="require('@/assets/images/default_profile.png')" alt="기본 프로필" :class="$style.profileImage" />
          </div>
          <span v-if="unreadNotificationCount > 0" :class="$style.profileAlarmBadge"></span>
        </button>


        <div v-if="showDropdown" :class="$style.dropdownMenu" @click.stop ref="dropdownMenu">
          <button v-if="userStore.auth === 'admin'" :class="$style.dropdownItem" @click="goToAdmin">
            관리자 메뉴
          </button>
          <button :class="$style.dropdownItem" @click="goToProfile">
            <span :class="$style.dropdownItemLabel">
              마이페이지
              <span v-if="unreadNotificationCount > 0" :class="$style.dropdownAlarmBadge"></span>
            </span>
          </button>
          <button :class="$style.dropdownItem" @click="goToMyReservations">
            예매내역
          </button>
          <!-- <button :class="$style.dropdownItem" @click="goToMyCalendar">
            캘린더
          </button>
          <button :class="$style.dropdownItem" @click="goToNotifications">
            알림
          </button> -->
          <button :class="$style.dropdownItem" @click="fullLogout">
            로그아웃
          </button>
        </div>
      </div>
    </div>

    <!-- 하단 네비게이션 바 -->
    <nav :class="$style.navBar" v-if="!isDetailPage">
      <div :class="[$style.navItem, { [$style.active]: $route.path === '/' }]" @click="handleNavClick('home')">
        <img :class="[$style.navIcon, { [$style.active]: $route.path === '/' }]" src="@/assets/images/family_home.png"
          alt="라이브" />
        <span :class="[$style.navText, { [$style.active]: $route.path === '/' }]">라이브</span>
      </div>
      <div :class="[
        $style.navItem,
        { [$style.active]: $route.path === '/artist' },
      ]" @click="handleNavClick('artist')">
        <img :class="[
          $style.navIcon,
          { [$style.active]: $route.path === '/artist' },
        ]" src="@/assets/images/family_star.png" alt="아티스트" />
        <span :class="[
          $style.navText,
          { [$style.active]: $route.path === '/artist' },
        ]">아티스트</span>
      </div>

      <div v-if="true" :class="[
        $style.navItem,
        { [$style.active]: $route.path === '/board' || $route.path.startsWith('/board/') },
      ]" @click="handleNavClick('community')">
        <img :class="[
          $style.navIcon,
          { [$style.active]: $route.path === '/board' || $route.path.startsWith('/board/') },
        ]" src="@/assets/images/diversity_3.png" alt="커뮤니티" />
        <span :class="[
          $style.navText,
          { [$style.active]: $route.path === '/board' || $route.path.startsWith('/board/') },
        ]">커뮤니티</span>
      </div>
      <div :class="[
        $style.navItem,
        { [$style.active]: $route.path === '/video' },
      ]" @click="handleNavClick('video')">
        <img :class="[
          $style.navIcon,
          { [$style.active]: $route.path === '/video' },
        ]" src="@/assets/images/videos.png" alt="동영상" />
        <span :class="[
          $style.navText,
          { [$style.active]: $route.path === '/video' },
        ]">동영상</span>
      </div>

      <div v-if="userStore.isLogin && userStore.auth === 'admin'" :class="[
        $style.navItem,
        { [$style.active]: $route.path === '/commission' },
      ]" @click="handleNavClick('commission')">
        <img :class="[
          $style.navIcon,
          { [$style.active]: $route.path === '/commission' },
        ]" src="@/assets/images/stack_star.png" alt="커미션" />
        <span :class="[
          $style.navText,
          { [$style.active]: $route.path === '/commission' },
        ]">커미션</span>
      </div>
      <div :class="[$style.navItem, { [$style.active]: $route.path === '/venue' }]" @click="handleNavClick('venue')">
        <img :class="[
          $style.navIcon,
          { [$style.active]: $route.path === '/venue' },
        ]" src="@/assets/images/family_group.png" alt="공연장" />
        <span :class="[
          $style.navText,
          { [$style.active]: $route.path === '/venue' },
        ]">공연장</span>
      </div>
      <!-- <div :class="[
        $style.navItem,
        { [$style.active]: $route.path === '/profile' },
      ]" @click="handleNavClick('profile')" style="position: relative;">
        <img :class="[
          $style.navIcon,
          { [$style.active]: $route.path === '/profile' },
        ]" src="@/assets/images/account_circle.png" alt="프로필" />
        <span v-if="userStore.isLogin && unreadNotificationCount > 0" :class="$style.profileBadge"></span>
        <span :class="[
          $style.navText,
          { [$style.active]: $route.path === '/profile' },
        ]">프로필</span>
      </div> -->
    </nav>
  </div>
</template>

<script>
import { useUserStore } from "@/store/user";
import { trackMenuClick } from "@/utils/statistics";
import { collection, query, where, getDocs } from "firebase/firestore";
import { firestore } from "/firebaseConfig";

export default {
  name: "LinkookLiveHeader",
  props: {
    onoff: Boolean,
  },
  data() {
    return {
      userStore: useUserStore(),
      showDropdown: false,
      windowWidth: window.innerWidth,
      unreadNotificationCount: 0,
    };
  },
  computed: {
    isDetailPage() {
      // navBar 숨김 페이지
      // const isMobile = this.windowWidth <= 1024;
      return (
        // isMobile &&
        this.$route.path.startsWith("/live/") ||
        this.$route.path.startsWith("/artist/") ||
        this.$route.path.startsWith("/board/") ||
        this.$route.path.startsWith("/video/") ||
        this.$route.path.startsWith("/commission/") ||
        this.$route.path === "/x-callback" ||
        this.$route.path.startsWith("/visitor-stats") ||
        this.$route.path.startsWith("/artist-stats") ||
        this.$route.path.startsWith("/venue-stats") ||
        this.$route.path.startsWith("/user-stats") ||
        this.$route.path.startsWith("/ad-management") ||
        this.$route.path.startsWith("/report-management") ||
        this.$route.path.startsWith("/alarm-management") ||
        this.$route.path.startsWith("/growth-overview") ||
        this.$route.path.startsWith("/traffic-stats") ||
        this.$route.path.startsWith("/about")
      );
    },
    isPageForHeader() {
      // liveDetail, artistDetail, boardDetail 페이지인지 확인
      return (
        this.$route.path === "/artist" ||
        this.$route.path === "/venue" ||
        this.$route.path === ("/board") ||
        this.$route.path === ("/video") ||
        this.$route.path === ("/commission") ||
        this.$route.path === "/about" ||
        this.$route.path.startsWith("/visitor-stats") ||
        this.$route.path.startsWith("/live-stats") ||
        this.$route.path.startsWith("/artist-stats") ||
        this.$route.path.startsWith("/venue-stats") ||
        this.$route.path.startsWith("/traffic-stats") ||
        this.$route.path.startsWith("/activity-stats") ||
        this.$route.path.startsWith("/like-stats") ||
        this.$route.path.startsWith("/user-stats") ||
        this.$route.path.startsWith("/activity-stats") ||
        this.$route.path.startsWith("/core-user-stats") ||
        this.$route.path.startsWith("/like-stats") ||
        this.$route.path.startsWith("/ad-management") ||
        this.$route.path.startsWith("/report-management") ||
        this.$route.path.startsWith("/alarm-management") ||
        this.$route.path.startsWith("/growth-overview")
      );
    },
  },
  async created() {
    // 사용자 정보 동기화
    if (this.userStore.isLogin) {
      await this.userStore.syncUserData();
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    window.addEventListener("resize", this.handleResize);

    // 초기 알림 개수 로드
    if (this.userStore.isLogin) {
      this.loadUnreadNotificationCount();
    }
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    "$route.path": async function () {
      // 라우트가 변경될 때마다 사용자 정보 동기화 및 알림 개수 갱신
      if (this.userStore.isLogin) {
        await this.userStore.syncUserData();
        this.loadUnreadNotificationCount();
      }
    },
    "userStore.isLogin": function (newVal) {
      // 로그인 상태가 변경될 때 알림 개수 갱신
      if (newVal) {
        this.loadUnreadNotificationCount();
      } else {
        this.unreadNotificationCount = 0;
      }
    }
  },
  methods: {
    handleNavClick(menu) {
      // 홈은 통계 수집 없이 바로 이동
      if (menu === "home") {
        this.goToHome();
        return;
      }

      // 프로필만 로그인 체크
      if (menu === "profile") {
        trackMenuClick(menu);
        if (!this.userStore.isLogin) {
          this.userStore.showLoginPopup('profile');
          return;
        }
        this.goToProfile();
        return;
      }

      // 나머지 메뉴는 로그인 없이도 접근 가능
      trackMenuClick(menu);

      switch (menu) {
        case "artist":
          this.goToArtist();
          break;
        case "community":
          this.goToCommunity();
          break;
        case "venue":
          this.goToVenue();
          break;
        case "commission":
          this.goToCommission();
          break;
        case "video":
          this.goToVideo();
          break;
      }
    },
    goToOff() {
      this.$router.push("/");
    },
    goToHome() {
      this.$router.push("/");
    },
    goToArtist() {
      this.$router.push("/artist");
    },
    goToCommunity() {
      this.$router.push("/board");
    },
    goToVenue() {
      this.$router.push("/venue");
    },
    goToCommission() {
      this.$router.push("/commission");
    },
    goToVideo() {
      this.$router.push("/video");
    },
    goToProfile() {
      this.showDropdown = false;
      this.$router.push("/profile");
    },
    goToMyReservations() {
      this.showDropdown = false;
      trackMenuClick("myReservations");
      this.$router.push("/my-reservations");
    },
    goToMyCalendar() {
      this.showDropdown = false;
      trackMenuClick("calendar");
      this.$router.push("/my-calendar");
    },
    goToNotifications() {
      this.showDropdown = false;
      trackMenuClick("notifications");
      this.$router.push("/notifications");
    },
    goToAdmin() {
      this.showDropdown = false;
      this.$router.push("/visitor-stats");
    },
    showLoginPopup() {
      this.userStore.showLoginPopup('general');
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    openNicknamePopup() {
      this.userStore.nicknamePopup = true;
      this.showDropdown = false;
    },
    fullLogout() {
      this.showDropdown = false;
      if (this.userStore) this.userStore.logOut();

      // 카카오 로그아웃 (에러 발생 시에도 계속 진행)
      try {
        if (window.Kakao && window.Kakao.Auth) {
          // 카카오 액세스 토큰이 있는 경우에만 로그아웃 시도
          const accessToken = window.Kakao.Auth.getAccessToken();
          if (accessToken) {
            window.Kakao.Auth.logout()
              .then(() => {
              })
              .catch((err) => {
                // 토큰 만료 등의 이유로 실패해도 무시
                console.warn(err);
              });
          }
        }
      } catch (error) {
        // 카카오 SDK 관련 에러 무시
        console.warn("카카오 로그아웃 처리 중 에러 (무시됨):", error.message);
      }

      this.$router.push("/");
    },
    handleClickOutside(e) {
      const dropdown = this.$refs.dropdownMenu;
      const trigger = this.$refs.profileTrigger;
      if (
        dropdown &&
        !dropdown.contains(e.target) &&
        trigger &&
        !trigger.contains(e.target)
      ) {
        this.showDropdown = false;
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    async loadUnreadNotificationCount() {
      if (!this.userStore.isLogin) {
        this.unreadNotificationCount = 0;
        return;
      }

      try {
        const notificationsRef = collection(firestore, "alarms");
        const q = query(
          notificationsRef,
          where("userId", "==", this.userStore.email),
          where("read", "==", false)
        );

        const querySnapshot = await getDocs(q);
        this.unreadNotificationCount = querySnapshot.size;
      } catch (error) {
        console.error("읽지 않은 알림 개수 로드 오류:", error);
        this.unreadNotificationCount = 0;
      }
    },
  },
};
</script>

<style module>
.header {
  width: 90%;
  display: flex;
  flex-direction: column;
  margin: auto;
  position: relative;
  max-width: 1024px;
}

/* 상단 헤더 (로고 + 로그인 버튼) */
.topHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  background: white;
  position: relative;
  z-index: 800;
}

.logoDiv {
  display: flex;
  align-items: center;
}

.logo {
  width: 220px;
  height: auto;
}

.buttons {
  display: flex;
  position: relative;
  align-items: center;
}

.loginButton {
  background: #ffffff;
  color: #333;
  border: 1px solid #ddd;
  cursor: pointer;
  padding: 7px 10px;
  border-radius: 10px;
  transition: all 0.3s ease;
  font-size: 12px;
  font-weight: bold;
  font-family: "NanumSquareRoundEB", sans-serif;
}

.loginButton:hover {
  background-color: #f8f9fa;
  transform: scale(1.05);
}

.profileButton {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profileAlarmBadge {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 7px;
  height: 7px;
  background: #66bdff;
  border-radius: 50%;
  border: 1px solid #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.profileImage {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ccc;
  margin-right: 3px;
}

.defaultProfile {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dropdownMenu {
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 8px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 801;
  min-width: 130px;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.dropdownItem {
  background: none;
  border: none;
  text-align: left;
  padding: 10px 18px;
  font-size: 15px;
  color: #222;
  cursor: pointer;
  transition: background 0.15s;
}

.dropdownItemLabel {
  position: relative;
  display: inline-flex;
  align-items: flex-start;
}

.dropdownAlarmBadge {
  position: absolute;
  top: 0;
  right: -9px;
  width: 7px;
  height: 7px;
  background: #66bdff;
  border-radius: 50%;
  border: 1px solid #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.dropdownItem:hover {
  background: #f2f2f2;
}

/* 하단 네비게이션 바 */
.navBar {
  display: flex;
  justify-content: center;
  gap: 0;
  background: #ffffff;
  padding: 0;
  margin: 0 auto;
  width: 100%;
  max-width: 1024px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 800;
  border-top: 1px solid #e5e5e5;
  border-radius: 0px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  /* 모바일 고정 안정화 */
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  will-change: transform;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -webkit-perspective: 1000;
  perspective: 1000;
  /* iOS Safari 최적화 */
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: none;
}

/* 메인 페이지가 아닐 때 상단 헤더 숨김 */
.header:not([data-is-home="true"]) .topHeader {
  display: none;
}

.navItem {
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  flex: 1;
  text-align: center;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.navItem:hover {
  background: rgba(102, 189, 255, 0.08);
}

.navIcon {
  width: 30px;
  height: 30px;
  display: block;
  filter: brightness(0) saturate(100%) invert(40%);
  /* #666666 색상 */
  transition: all 0.2s ease;
}

.navText {
  color: #666666;
  font-size: 10px;
  font-weight: 500;
  font-family: "NanumSquareRoundR", sans-serif;
  text-decoration: none;
  transition: all 0.2s ease;
  position: relative;
  z-index: 1;
}

.navItem:hover .navText {
  color: #66bdff;
}

.navItem:hover .navIcon {
  filter: brightness(0) saturate(100%) invert(68%) sepia(97%) saturate(1200%) hue-rotate(182deg) brightness(105%) contrast(101%);
  /* #66bdff 색상 */
}

.navItem:active .navText {
  color: #66bdff;
  font-weight: 600;
}

.navItem:active .navIcon {
  filter: brightness(0) saturate(100%) invert(68%) sepia(97%) saturate(1200%) hue-rotate(182deg) brightness(105%) contrast(101%);
}

/* 현재 페이지 active 상태 */
.navText.active {
  color: #66bdff;
  font-weight: 600;
}

.navIcon.active {
  filter: brightness(0) saturate(100%) invert(68%) sepia(97%) saturate(1200%) hue-rotate(182deg) brightness(105%) contrast(101%);
}

.navItem.active {
  background: rgba(102, 189, 255, 0.1);
}

.profileBadge {
  position: absolute;
  top: 8px;
  right: 44%;
  transform: translateX(12px);
  width: 8px;
  height: 8px;
  background: #66bdff;
  border-radius: 50%;
  border: 1px solid #333;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  z-index: 2;
}

/* ==============================================
   반응형 디자인
   - Medium: 481px ~ (기본 스타일, 최대 1024px)
   - Small: ~480px
   ============================================== */

/* Small (~480px) - 모바일 */
@media screen and (max-width: 480px) {
  .topHeader {
    padding: 8px 0px;
  }

  .logo {
    width: 150px;
  }

  .loginButton {
    font-size: 11px;
    padding: 6px 8px;
  }

  .profileImage {
    width: 28px;
    height: 28px;
    border: 1px solid #ccc;
  }

  .defaultProfile {
    width: 28px;
    height: 28px;
  }

  .navItem {
    padding: 10px 6px;
    gap: 5px;
  }

  .navText {
    font-size: 8px;
  }

  .navIcon {
    width: 24px;
    height: 24px;
    display: block;
  }

  .profileBadge {
    top: 8px;
    right: 44%;
    transform: translateX(10px);
    width: 6px;
    height: 6px;
  }

  .profileAlarmBadge {
    width: 6px;
    height: 6px;
  }

  /* 모바일에서 navBar 고정 강화 */
  .navBar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000;
    perspective: 1000;
  }
}
</style>
